import script from "./MoneyReceiptForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyReceiptForm.vue?vue&type=script&setup=true&lang=js"

import "./MoneyReceiptForm.vue?vue&type=style&index=0&id=6cb0dd1a&setup=true&lang=css"

const __exports__ = script;

export default __exports__